import type { PlayerTrackerConfig } from '../../playerTracker.types.ts';

const PLAYER_TRACKER: PlayerTrackerConfig = {
  impressions: {},
};

export { PLAYER_TRACKER };
